import { AnnouncementStoreState, FrontPageState } from './state';
import { Action, createReducer, on, ActionReducerMap, State } from '@ngrx/store';
import * as FrontPageAnnouncementActions from './announcement-front-page-actions';
import { SearchPageReducer } from './search-page';
import { AnnouncementDetailsReducer } from './ann-details-page';
import { searchFieldReducer } from './front-page/search-field/reducer';
import { selectVipCvAnnouncements } from './selectors';
import { state } from '@angular/animations';


let initialState: FrontPageState = {
  announcements: [],
  loading: false,
  loadingMore: false,
  metaDataLoading: false,
  metaData: null,
  frontPageCityLinks: null,
  favoriteAnnouncements: [],
  cvBoxDecorateAnnouncementCustomerIds: [],
  frontPageFailureDetails: null,
  bannerList: [],
  page: 1,
  hasMorePages: false,
  bannerListLoading: false,
  isCvBoxSliderVisible: false
};

const reducer = createReducer(
  initialState,
  on(FrontPageAnnouncementActions.loadFrontPageAnnouncements, (state, { payload }) => ({
    ...state,
    loading: true,
    loadingMore: payload.page > 1,
  })),
  on(
    FrontPageAnnouncementActions.loadFrontPageAnnouncementsSuccess,
    (state, { payload }) => ({
      ...state,
      announcements: [...state.announcements, ...payload.announcementList],
      cvBoxDecorateAnnouncementCustomerIds: payload.cvBoxDecorateAnnouncementCustomerIds,
      hasMorePages: payload.hasMorePages,
      page: state.page + 1,
      loading: false,
      loadingMore: false,
      frontPageFailureDetails: null
    })
  ),
  on(
    FrontPageAnnouncementActions.loadFrontPageAnnouncementsFail,
    (state, { payload }) => ({
      ...state,
      loading: false,
      loadingMore: false,
      frontPageFailureDetails: payload.error
    })
  ),

  on(
    FrontPageAnnouncementActions.loadFrontPageAnnouncementsSkipped,
    (state) => ({
      ...state,
      loading: false,
      loadingMore: false,
    })
  ),

  on(
    FrontPageAnnouncementActions.loadFrontPageMetaData, (state) => ({
      ...state,
      metaDataLoading: true
    })
  ),
  on(
    FrontPageAnnouncementActions.loadFrontPageMetaDataSuccess,
    (state, { payload }) => ({
      ...state,
      metaDataLoading: false,
      metaData: payload.metaData,
      frontPageCityLinks: payload.frontPageCityLinks,
    })
  ),
  on(
    FrontPageAnnouncementActions.loadFrontPageMetaDataFail,
    (state, { payload }) => ({
      ...state,
      metaDataLoading: false
    })
  ),
  on(
    FrontPageAnnouncementActions.showCvBoxSlider,
    (state, { payload }) => ({
      ...state,
      isCvBoxSliderVisible: payload
    })
  ),
  on(
    FrontPageAnnouncementActions.loadFavoriteAnnouncements, (state) => ({
      ...state,
      loading: true
    })
  ),
  on(
    FrontPageAnnouncementActions.loadFavoriteAnnouncementsSuccess,
    (state, { payload }) => ({
      ...state,
      loading: false,
      favoriteAnnouncements: payload
    })
  ),
  on(
    FrontPageAnnouncementActions.loadFavoriteAnnouncementsFail,
    (state, { payload }) => ({
      ...state,
      loading: false
    })
  ),
  on(
    FrontPageAnnouncementActions.getFrontPageBannerList,
    (state, { payload }) => ({
      ...state,
      bannerListLoading: true
    })
  ),
  on(
    FrontPageAnnouncementActions.getFrontPageBannerListSuccess,
    (state, { payload }) => ({
      ...state,
      bannerList: payload,
      bannerListLoading: false
    })
  ),
  on(
    FrontPageAnnouncementActions.getFrontPageBannerListFailed,
    (state, { payload }) => ({
      ...state,
      bannerListLoading: false
    })
  ),

);

export function announcementReducer(
  state: FrontPageState | undefined,
  action: Action
) {
  return reducer(state, action);
}
export const reducers: ActionReducerMap<AnnouncementStoreState> = {
  search: SearchPageReducer.announcementReducer,
  frontpage: announcementReducer,
  announcementDetails: AnnouncementDetailsReducer.announcementDetailsReducer,
  searchFieldState: searchFieldReducer,
  //lookup: SearchPageReducer.lookupReducer
};
